import img from "../US_img/27Cabine acoustique design pour bureau open space – isolation phonique et confort acoustique.webp"; // adapte le chemin image
import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

const Feature = ({ icon, title, text }) => (
  <div className="us-feature">
    <div data-aos="fade-up" className="us-feature-icon">{icon}</div>
    <h4 data-aos="fade-up">{title}</h4>
    <p data-aos="fade-up">{text}</p>
  </div>
);

const SectionTitle = ({ small, big }) => (
  <div className="us-section-title">
    <span data-aos="fade-up">{small}</span>
    <h2 data-aos="fade-up">{big}</h2>
  </div>
);

export default function UsAcousticCabine() {

  useEffect(() => {
    AOS.init({
      duration: 1500,
      once: true,
    });
  }, []);

  return (
    <div className="us-page">

      {/* HERO */}
      <section className="us-hero">
        <div className="us-hero-content">
          <div data-aos="fade-right" className="us-badge">
            <h3>
              <span className="subtitle-us">US</span> <b>ACOUSTIC</b>
            </h3>
          </div>

          <h1 data-aos="fade-up">Cabine acoustique</h1>

          <p data-aos="fade-up">
            Les cabines acoustiques US Acoustic sont conçues pour créer
            des espaces isolés phoniquement au sein d’environnements ouverts.
            Elles offrent un confort sonore optimal pour travailler,
            téléphoner ou organiser des réunions en toute confidentialité.
          </p>

          <div data-aos="zoom-in" className="us-hero-buttons">
            <a className="btn-primarya" href="/devis">
              Demander un devis
            </a>
            <a
              href="/docs/fiche-technique-us-acoustic-cabine.pdf"
              download
              className="btn-outline"
            >
              Télécharger la fiche technique
            </a>
          </div>
        </div>

        <div data-aos="fade-up" className="us-hero-image">
          <img src={img} alt="US Acoustic cabine acoustique" />
        </div>
      </section>

      {/* DESCRIPTION */}
      <section className="us-section">
        <SectionTitle
          small="Présentation"
          big="Qu’est-ce que la cabine acoustique US ACOUSTIC ?"
        />

        <div className="us-two-cols">
          <p data-aos="fade-up">
            La cabine acoustique US ACOUSTIC est une solution modulaire
            permettant de créer rapidement des espaces de confidentialité
            dans les bureaux, open spaces ou lieux publics.
            Elle réduit efficacement les nuisances sonores.
          </p>

          <p data-aos="fade-up">
            Conçue avec des matériaux acoustiques haute performance,
            elle combine isolation phonique, ventilation intégrée
            et design contemporain pour s’intégrer parfaitement
            dans les environnements professionnels modernes.
          </p>
        </div>
      </section>

      {/* AVANTAGES */}
      <section className="us-section us-gray">
        <SectionTitle small="Atouts" big="Avantages clés" />

        <div className="us-grid">
          <Feature
            icon="🔇"
            title="Isolation phonique"
            text="Réduction efficace du bruit pour une confidentialité maximale."
          />
          <Feature
            icon="🏢"
            title="Idéale open space"
            text="Parfaite pour bureaux modernes et espaces collaboratifs."
          />
          <Feature
            icon="🧩"
            title="Modulaire"
            text="Configuration adaptable selon les besoins du projet."
          />
          <Feature
            icon="🌬️"
            title="Ventilation intégrée"
            text="Confort d’utilisation même en usage prolongé."
          />
          <Feature
            icon="🎨"
            title="Design personnalisable"
            text="Finitions, couleurs et dimensions sur mesure."
          />
          <Feature
            icon="⚡"
            title="Installation rapide"
            text="Mise en œuvre propre et rapide sur site."
          />
        </div>
      </section>

      {/* TECHNIQUE */}
      <section className="us-section">
        <SectionTitle small="Technique" big="Caractéristiques techniques" />

        <ul data-aos="fade-up" className="us-list">
          <li>Cabine acoustique modulaire</li>
          <li>Haute performance d’isolation phonique</li>
          <li>Structure robuste et durable</li>
          <li>Ventilation silencieuse intégrée</li>
          <li>Éclairage LED intérieur</li>
          <li>Installation rapide sans gros travaux</li>
        </ul>
      </section>

      {/* APPLICATIONS */}
      <section className="us-section us-gray">
        <SectionTitle small="Applications" big="Domaines d’utilisation" />

        <div className="us-tags" data-aos="fade-up">
          {[
            "Open spaces",
            "Bureaux",
            "Salles de réunion",
            "Centres d’appels",
            "Espaces coworking",
            "Hôtels",
            "Aéroports",
            "Espaces publics",
          ].map((item) => (
            <span key={item}>{item}</span>
          ))}
        </div>
      </section>

      {/* CTA */}
      <section className="us-cta">
        <h2>Créez vos espaces de confidentialité</h2>
        <p>
          Les cabines US ACOUSTIC améliorent le confort sonore
          et la productivité de vos espaces.
        </p>
        <br />
        <a href="/contact" className="btn-primarya">
          Contactez-nous
        </a>
      </section>

    </div>
  );
}
